module.exports = __webpack_public_path__ + "media/assets/images/blog/makeIThappen-small-a3614edabbeccd902a1c733f48a1f9db.jpg";